import auth from "../middlewares/auth";
export const scrollNotice = [
    {
        path: '/scroll-notice',
        component: () => import(/* webpackChunkName: "notice" */ '../views/scroll-notice/Index'),
        name: 'scroll_notice',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/scroll-notice/add',
        component: () => import(/* webpackChunkName: "notice" */ '../views/scroll-notice/Form'),
        name: 'scroll_notice_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/scroll-notice/edit/:id',
        component: () => import(/* webpackChunkName: "notice" */ '../views/scroll-notice/Form'),
        name: 'scroll_notice_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
